import {
  always,
  pipe,
  filter,
  identity,
  isEmpty,
  isNil,
  join,
  path,
  when,
} from "ramda";

export const formatContributorName = (contributor, isRtl = false) => {
  return (
    contributor.corporationName ||
    [
      contributor.prefix,
      contributor.firstName,
      contributor.middleName,
      contributor.lastName,
      contributor.suffix,
      contributor.role ? `(${contributor.role.display})` : void 0,
    ].join(" ")
  );
};

export const EMPTY = "---";

export const isFieldPopulated = (p, fields) => {
  const value = path(p, fields);
  return !isNil(value) && !isEmpty(value);
};

export const getFieldValueOrEmpty = (p, fields) =>
  isFieldPopulated(p, fields) ? path(p, fields) : EMPTY;

export const getNameOrEmpty = pipe(
  filter(identity),
  join(" "),
  when(isEmpty, always("---"))
);

export const getFieldOptionLabel = (prop, fieldOptions) =>
  fieldOptions[prop]?.fieldLabel?.toLocaleLowerCase().replaceAll(" ", "-") ??
  prop;

// export const isFullNamePopulated = person =>
//   !isEmpty(person.firstName) && !isEmpty(person.lastName);
